export { default } from './FakeBrowserWindow';
